import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  ConfirmationModal: {
    marginTop: '15%',
    width: '100%',
    height: '100vh',
    '&__delete-form-container': {
      background: 'rgba(11, 17, 32, 0.95)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(14, 165, 233, 0.15)',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      boxShadow: '0 16px 48px rgba(0, 0, 0, 0.4)',
      color: '#F8FAFC',
      margin: '0 auto',
      '&__button': {
        '&--error': {
          backgroundColor: `${theme.palette.error.main} !important`,
        },
        '&--success': {
          backgroundColor: `${theme.palette.success.main} !important`,
        },
        '&__pick': {
          borderRadius: '0px',
          height: '50px',
        },
      },
      '&__dimensions': {
        height: '300px',
        width: '600px',
        '&--small': {
          height: '100px !important',
        },
      },
      '&__icon': {
        backgroundColor: '#06B6D4',
        borderRadius: '50%',
        color: theme.palette.white,
        height: '40px',
        left: '0',
        margin: '0 auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'absolute',
        right: '0',
        top: '-18px',
        width: '40px',
        '&__header': {
          fontSize: '30px',
          width: '100%',
        },
        '&__wrapper': {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          margin: '0 auto',
        },
      },
      '&__information-container': {
        backgroundColor: theme.palette.primary.main,
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        height: '4px',
        position: 'relative',
        width: '100%',
        '&__wrapper': {
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '20px',
        },
      },
      '&__row': {
        '&--display': {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        },
        '&--height': {
          height: '100%',
        },
      },
    },
  },
}));

export { useStyles };
